import { useMutation } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { logger } from "@/core/utils/func/logger";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type {
  NonMemberCodeVerifyRequest,
  NonMemberCodeVerifyResponse,
} from "@/features/wallet/api/dto";

/**
 * Vérifie un code Non-Member + téléphone **sans effet financier**
 * (`POST /NonMemberCodes/verify`, guide v2.4 §6.3).
 *
 * Retourne le montant, le nom d'affichage du destinataire (à confronter à la
 * pièce présentée) et la date d'expiration. 5 échecs de vérification bloquent
 * **définitivement** le code (422). Codes : 404 code inconnu ; 422 code
 * expiré/annulé/bloqué/non confirmé/téléphone incohérent.
 */
export const useVerifyNonMemberCode = () =>
  useMutation({
    mutationKey: ["wallet", "nonMemberCodes", "verify"],
    mutationFn: (body: NonMemberCodeVerifyRequest) =>
      mutateData({
        url: walletEndpoints.nonMemberCodes.verify,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<NonMemberCodeVerifyResponse>,
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useVerifyNonMemberCode failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "wallet" }
      );
    },
  });
